<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-crediti-imposta d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Crediti d'imposta</PageTitle>
        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.data-analysis.crediti-imposta.add' }">
          Aggiungi credito d'imposta
        </app-router-link>
      </div>

      <CreditiImpostaListTable class="report-texts-size" :crediti="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeCreditoImposta" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';
import loadingDataMixin from '../../../../../mixins/loadingData';
import confirmWithModalMixin from '../../../../../libs/Confirm/mixins/confirmWithModal';

export default {
  mixins: [operativePageMixin, loadingDataMixin, confirmWithModalMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    CreditiImpostaListTable: () => import('../../../../components/Operative/ListTable/CreditiImpostaListTable'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  data () {
    return {
      results: null,
    };
  },
  methods: {
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getCreditiImposta(this.company?.id)
        .then(res => {
          this.results = res?.data?.creditiImposta || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeCreditoImposta (id) {
      this.confirm('Cancellare il credito di imposta selezionato? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteCreditoImposta(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.retrieveListData();
      },
    },
  },
};

</script>
